import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { DataObjectUrl } from './DataObjectUrl';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import type { DataObjectSearchResultType } from '../schema';

export const getSelectedDataObjects = (dataObjectIds?: number[]) => {
  if (!dataObjectIds || !dataObjectIds.length) {
    return [];
  }
  return apiClient
    .get<DataObjectSearchResultType[]>(
      expand(DataObjectUrl.SELECTED, {
        dataObjectIds,
      })
    )
    .then((response) => {
      return response.data;
    });
};

export const useSelectedDataObjectsQuery = createApiQueryHook(
  ['selectedDataObjects'],
  getSelectedDataObjects
);
